module.exports = __webpack_public_path__ + "img/lock_keyboard.12c43657.png";